var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIfinal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 550.143,
    height: 79.411,
    viewBox: "0 0 550.143 79.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12635",
    "data-name": "Group 12635",
    transform: "translate(-4587.693 1126.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y2: 79.411,
    transform: "translate(4676.583 -1126.5)",
    fill: "none",
    stroke: "#1a1818",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12629",
    "data-name": "Group 12629",
    transform: "translate(4587.693 -1119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M600.623,656.113l3.2.119a19.834,19.834,0,0,1,5.639,1,11.864,11.864,0,0,1,5.968,4.057c1.582,2.133,2.531,4.844,1.138,7.869a8.418,8.418,0,0,1-5.3,4.5l-.037.011a17.782,17.782,0,0,1-5.547.724c-.341-.01-.682-.019-1.023-.015h0a3.815,3.815,0,0,0-3.8,3.815v23.98a3.473,3.473,0,0,1-3.486,3.472l-7.932-.031.089-27.676a3.481,3.481,0,0,0-3.441-3.492l-.646-.007a3.881,3.881,0,0,0-3.925,3.866l-.116,31.581a3.339,3.339,0,0,0,3.341,3.352l20.583-.012a3.487,3.487,0,0,0,3.485-3.487V683.732a2.68,2.68,0,0,1,2.525-2.675l1.212-.07a16.886,16.886,0,0,0,5.792-1.371c3.158-1.381,5.011-2.714,6.623-5.666,2.115-3.87,3.327-10.288-1.333-16.985a21.789,21.789,0,0,0-17.876-9.51h-9.991Z",
    transform: "translate(-577.098 -647.455)",
    fill: "#072a52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M580.782,765.7a4.084,4.084,0,0,1,4.18-4.118,4,4,0,0,1,4.354,3.727v12.37l-4.267-4.646-4.267,4.646Z",
    transform: "translate(-576.621 -735.081)",
    fill: "#ff6e0d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M562.861,707.968a.842.842,0,0,1,.456-.4q4.15-1.854,8.295-3.718a.823.823,0,0,1,.739,0q4.152,1.872,8.312,3.725c.363.161.573.517.346.856a.34.34,0,0,0-.029.178c0,1.5,0,3,0,4.5a.236.236,0,0,0,.149.239,1.368,1.368,0,0,1-.759,2.559,1.371,1.371,0,0,1-1.265-1.087,1.392,1.392,0,0,1,.677-1.48.277.277,0,0,0,.131-.188c.007-1.37.006-2.741,0-4.112a1.01,1.01,0,0,0-.013-.107c-.066.017-.124.028-.18.046-.579.191-1.155.389-1.737.57a.212.212,0,0,0-.174.248c.005,1.173,0,2.346,0,3.519a.6.6,0,0,1-.224.539.614.614,0,0,1-.577.052c-.792-.226-1.581-.475-2.385-.644a13.153,13.153,0,0,0-3.479-.227,15.2,15.2,0,0,0-4.237.874.521.521,0,0,1-.749-.543c0-1.173,0-2.346,0-3.519a.246.246,0,0,0-.2-.286c-.87-.291-1.734-.6-2.6-.892a.755.755,0,0,1-.5-.4Z",
    transform: "translate(-562.861 -690.683)",
    fill: "#072a52"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12630",
    "data-name": "Group 12630",
    transform: "translate(4727.195 -1120)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M476.906,189.039a3.31,3.31,0,0,1-.972-2.516,3.347,3.347,0,0,1,.972-2.472,3.412,3.412,0,0,1,4.768,0,3.354,3.354,0,0,1,.971,2.472,3.4,3.4,0,0,1-5.739,2.516Z",
    transform: "translate(-475.934 -183.079)",
    fill: "#ff6e0d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 3.973,
    height: 47.942,
    transform: "translate(1.325 17.57)",
    fill: "#111415"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M595.7,220.676q-5.121,4.548-15.186,4.547H567.266v27.194h-3.973V190.436H580.51q10.242,0,15.275,4.723t5.033,12.758Q600.817,216.129,595.7,220.676Zm1.148-12.758q0-6.8-3.885-10.374t-12.45-3.576H567.266v27.723H580.51Q596.844,221.691,596.844,207.918Z",
    transform: "translate(-521.355 -186.904)",
    fill: "#111415"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M707.5,229.957a20.952,20.952,0,0,1,8.211-8.564,23.684,23.684,0,0,1,11.963-3,21.915,21.915,0,0,1,12.891,3.708,19.681,19.681,0,0,1,7.417,9.448V219.009h3.974v47.942h-3.974V254.326a19.784,19.784,0,0,1-7.461,9.58,21.775,21.775,0,0,1-12.847,3.752,23.4,23.4,0,0,1-11.963-3.046,21.169,21.169,0,0,1-8.211-8.653,30.052,30.052,0,0,1,0-26Zm37.877,1.9a18.573,18.573,0,0,0-7.107-7.417,19.745,19.745,0,0,0-10.066-2.6,20.319,20.319,0,0,0-10.242,2.517,17.338,17.338,0,0,0-6.887,7.284,27.071,27.071,0,0,0,0,22.6A17.545,17.545,0,0,0,718,261.566a21.253,21.253,0,0,0,20.307-.044,18.179,18.179,0,0,0,7.107-7.417,23.429,23.429,0,0,0,2.56-11.169A22.92,22.92,0,0,0,745.374,231.855Z",
    transform: "translate(-594.793 -201.439)",
    fill: "#111415"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M889.683,220.436q4.5-2.781,11.478-2.781v4.15h-1.324a17.391,17.391,0,0,0-11.743,4.017q-4.681,4.018-4.679,13.111v27.636h-3.974V218.627h3.974v9.888A14.569,14.569,0,0,1,889.683,220.436Z",
    transform: "translate(-685.73 -201.056)",
    fill: "#111415"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M1025.371,205.123q5.385,5.253,5.386,15.583v28.077h-3.885V220.971q0-8.563-4.327-13.111t-11.742-4.547q-7.771,0-12.4,4.945t-4.635,14.656v25.87h-3.973V183.447h3.973v27.547a15.868,15.868,0,0,1,6.8-8.255,20.819,20.819,0,0,1,10.948-2.87Q1019.985,199.869,1025.371,205.123Z",
    transform: "translate(-743.104 -183.27)",
    fill: "#111415"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M1148.154,229.957a20.952,20.952,0,0,1,8.212-8.564,23.683,23.683,0,0,1,11.963-3,21.914,21.914,0,0,1,12.89,3.708,19.684,19.684,0,0,1,7.417,9.448V219.009h3.973v47.942h-3.973V254.326a19.789,19.789,0,0,1-7.461,9.58,21.772,21.772,0,0,1-12.846,3.752,23.4,23.4,0,0,1-11.963-3.046,21.169,21.169,0,0,1-8.212-8.653,30.053,30.053,0,0,1,0-26Zm37.877,1.9a18.574,18.574,0,0,0-7.107-7.417,19.745,19.745,0,0,0-10.066-2.6,20.319,20.319,0,0,0-10.242,2.517,17.334,17.334,0,0,0-6.886,7.284,27.066,27.066,0,0,0,0,22.6,17.543,17.543,0,0,0,6.931,7.329,21.253,21.253,0,0,0,20.307-.044,18.178,18.178,0,0,0,7.107-7.417,23.43,23.43,0,0,0,2.561-11.169A22.925,22.925,0,0,0,1186.031,231.855Z",
    transform: "translate(-823.905 -201.439)",
    fill: "#111415"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M1318.31,189.039a3.311,3.311,0,0,1-.971-2.516,3.349,3.349,0,0,1,.971-2.472,3.412,3.412,0,0,1,4.768,0,3.354,3.354,0,0,1,.971,2.472,3.4,3.4,0,0,1-5.739,2.516Z",
    transform: "translate(-913.408 -183.079)",
    fill: "#ff6e0d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 3.973,
    height: 47.942,
    transform: "translate(405.255 17.57)",
    fill: "#111415"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfinal);
export default __webpack_public_path__ + "static/media/ifinal.514ac9fa6a574c2be1c1779a40fb08cc.svg";
export { ForwardRef as ReactComponent };